import { render, staticRenderFns } from "./scene-stuntextra.vue?vue&type=template&id=18d4f5c7&scoped=true&"
import script from "./scene-stuntextra.vue?vue&type=script&lang=js&"
export * from "./scene-stuntextra.vue?vue&type=script&lang=js&"
import style0 from "./scene-stuntextra.vue?vue&type=style&index=0&id=18d4f5c7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18d4f5c7",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/fcs/fcs/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('18d4f5c7')) {
      api.createRecord('18d4f5c7', component.options)
    } else {
      api.reload('18d4f5c7', component.options)
    }
    module.hot.accept("./scene-stuntextra.vue?vue&type=template&id=18d4f5c7&scoped=true&", function () {
      api.rerender('18d4f5c7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/scene-stuntextra.vue"
export default component.exports